import { ProductModelService } from "../models";
import { Series, Inverter, Range } from "../telemetry";
import { maskIdMeter, isProductMeter } from "../utils";

export class Meter {
  product: ProductModelService;

  constructor(id: string) {
    this.product = new ProductModelService(id);
    if (this.product.type?.name !== 'meter') {
      throw new Error('Product is not a meter');
    }
  }

  getDeviceTs(): string {
    const serial = this.product.id.toUpperCase();
    return `
    ${maskIdMeter(serial)}: getInverterData(serial: "${serial}") {
        TS
    }
  `;
  }

  static FromTotalEnergyToDailyEnergy(data: { [key: string]: Partial<Inverter>[] }): { [key: string]: Partial<Inverter>[] } {

    const result: { [key: string]: Partial<Inverter>[] } = {};

    for (const key of Object.keys(data)) {
      result[key] = data[key];
    }

    const hasMeter = Object.keys(result).some(key => isProductMeter(new ProductModelService(key)));

    if (!hasMeter) {
      return result;
    }

    for (const key of Object.keys(result)) {
      if (!isProductMeter(new ProductModelService(key))) {
        continue;
      }

      if (result[key].length < 2) {
        continue;
      }

      const meterData = [...result[key]].sort((a, b) => a.TS! - b.TS!);
      const meterDataClone = [...meterData];
      meterData.shift();
      result[key] = meterData.map((item, index) => {
        return {
          ...item,
          EG2: `${Number(item.ET2) - Number(meterDataClone[index].ET2)}`,
          EG3: `${Number(item.ET3) - Number(meterDataClone[index].ET3)}`,
          TS: item.TS
        };
      });

      result[key].forEach(item => {
        delete item.ET2;
        delete item.ET3;
      });
    }

    return result;
  }

  static GetLastPackage(data: { [key: string]: Partial<Inverter>[] }): { [key: string]: Partial<Inverter> } {
    const result: { [key: string]: Partial<Inverter> } = {};

    Object.keys(data).forEach((key) => {
      result[key] = [...data[key]].pop() || {};
    });

    return result;
  }
}
